// extracted by mini-css-extract-plugin
module.exports = {"cherBtn":"styles-module__cherBtn___2UGrJ"};